
class PrivateKey {
  constructor(algorithm) {
    this.algorithm = algorithm;
  }

  
}

export default PrivateKey;
